import { render } from "./Tokenomics.vue?vue&type=template&id=6a326ec8&scoped=true"
import script from "./Tokenomics.vue?vue&type=script&lang=js"
export * from "./Tokenomics.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6a326ec8"

export default script